import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProposalForm from './components/ProposalForm';
import SuccessPage from './components/SuccessPage';
import { getLanguage, setLanguage, t } from './utils/translations';
import './App.css';

function App() {
  const [lang, setLang] = useState(getLanguage());
  const [updateKey, setUpdateKey] = useState(0);

  useEffect(() => {
    setLanguage(lang);
    // Force re-render of all components
    setUpdateKey(prev => prev + 1);
  }, [lang]);

  return (
    <Router>
      <div className="App">
        <header className="App-header">
          <div className="header-content">
            <div>
              <h1>{t('appTitle')}</h1>
              <p>{t('appSubtitle')}</p>
            </div>
            <div className="language-selector">
              <button 
                className={lang === 'tr' ? 'lang-btn active' : 'lang-btn'}
                onClick={() => setLang('tr')}
              >
                TR
              </button>
              <button 
                className={lang === 'en' ? 'lang-btn active' : 'lang-btn'}
                onClick={() => setLang('en')}
              >
                EN
              </button>
              <button 
                className={lang === 'fr' ? 'lang-btn active' : 'lang-btn'}
                onClick={() => setLang('fr')}
              >
                FR
              </button>
            </div>
          </div>
        </header>
        <main className="App-main" key={updateKey}>
          <Routes>
            <Route path="/" element={<ProposalForm />} />
            <Route path="/success" element={<SuccessPage />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
